export enum BibleNotifications {
  BIBLE_CREATED = 'BIBLE_CREATED',
  BIBLE_PROGRESS = 'BIBLE_PROGRESS',
  BIBLE_UPDATED = 'BIBLE_UPDATED',
}

export enum OcrNotifications {
  OCR_PROGRESS = 'OCR_PROGRESS',
  OCR_FINISHED = 'OCR_FINISHED',
  OCR_ERROR = 'OCR_ERROR',
}

export enum RedactionNotifications {
  REDACTION_FINISHED = 'REDACTION_FINISHED',
  REDACTION_ERROR = 'REDACTION_ERROR',
}
